// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 245 ? "component---src-pages-index-tsx" : chunkId) + "-" + {"245":"67998b62e7f932eac504","522":"23ce2191c30c5daa34ad"}[chunkId] + ".js";
};